interface AggProjectTabConfig {
	id: string;
}

interface AggProjectTabs {
	about: AggProjectTabConfig;
	updates: AggProjectTabConfig;
	learnings: AggProjectTabConfig;
	risks: AggProjectTabConfig;
	decisions: AggProjectTabConfig;
}

const aggProjectTabs: AggProjectTabs = {
	about: {
		id: 'agg-project-about-tab',
	},
	updates: {
		id: 'agg-project-updates-tab',
	},
	learnings: {
		id: 'agg-project-learnings-tab',
	},
	risks: {
		id: 'agg-project-risks-tab',
	},
	decisions: {
		id: 'agg-project-decisions-tab',
	},
};

export const AGG_PROJECT_TABS: typeof aggProjectTabs = aggProjectTabs;

export type AggProjectTabName = keyof typeof AGG_PROJECT_TABS;

export const DEFAULT_TAB: AggProjectTabName = 'about';

export const isAggProjectTab = (tabName: string): tabName is AggProjectTabName => {
	return tabName in AGG_PROJECT_TABS;
};
